export type ENV =  "local" | "dev" | "stg" | "qa" | "prod";

export const env: ENV = process.env.REACT_APP_ENV as ENV || "local";
